import create from './createAction'

export const SELECT_PARTICIPANT = 'SELECT_PARTICIPANT'
export const CLEAR_PARTICIPANT = 'CLEAR_PARTICIPANT'
export const SET_VALUES = 'SET_VALUES'
export const REMOVE_MEMBER = 'REMOVE_MEMBER'
export const REMOVE_MEMBER_ITEMS = 'REMOVE_MEMBER_ITEMS'
export const SET_CURRENT_REGISTRATION = 'SET_CURRENT_REGISTRATION'
export const VALIDATE_SESSIONS = 'VALIDATE_SESSIONS'
export const SUBMIT_REGISTRATIONS = 'SUBMIT_REGISTRATIONS'
export const SET_ORDER_ID = 'SET_ORDER_ID'
export const SET_REGISTRATION_DATA = 'SET_REGISTRATION_DATA'
export const SET_SESSIONS = 'SET_SESSIONS'
export const RESET_FORM = 'RESET_FORM'
export const CREATE_VALIDATE_SESSION = 'CREATE_VALIDATE_SESSION'
export const VALIDATE_SESSION = 'VALIDATE_SESSION'
export const SET_SESSION_ID = 'SET_SESSION_ID'
export const SET_INITIAL_PAYMENT_GATEWAY = 'SET_INITIAL_PAYMENT_GATEWAY'
export const SET_TEAM_VALUES = 'SET_TEAM_VALUES'
export const REMOVE_TEAM = 'REMOVE_TEAM'
export const REMOVE_TEAM_ITEMS = 'REMOVE_TEAM_ITEMS'
export const SET_TEAM_CODE = 'SET_TEAM_CODE'

export const selectParticipant = create(SELECT_PARTICIPANT)
export const clearParticipant = create(CLEAR_PARTICIPANT)
export const setValues = create(SET_VALUES)
export const removeMember = create(REMOVE_MEMBER)
export const removeMemberItems = create(REMOVE_MEMBER_ITEMS)
export const setCurrentRegistration = create(SET_CURRENT_REGISTRATION)
export const validateSessions = create(VALIDATE_SESSIONS)
export const setSessions = create(SET_SESSIONS)
export const submitRegistrations = create(SUBMIT_REGISTRATIONS)
export const setOrderId = create(SET_ORDER_ID)
export const setRegistrationData = create(SET_REGISTRATION_DATA)
export const resetForm = create(RESET_FORM)
export const createAndValidateSession = create(CREATE_VALIDATE_SESSION)
export const validateSession = create(VALIDATE_SESSION)
export const setSessionId = create(SET_SESSION_ID)
export const setInitialPaymentGateway = create(SET_INITIAL_PAYMENT_GATEWAY)
export const setTeamValues = create(SET_TEAM_VALUES)
export const removeTeam = create(REMOVE_TEAM)
export const removeTeamItems = create(REMOVE_TEAM_ITEMS)
export const setTeamCode = create(SET_TEAM_CODE)
